// extracted by mini-css-extract-plugin
export default {"titleRow":"SpeedChartStatsHeader_titleRow__0WpRK","statsRow":"SpeedChartStatsHeader_statsRow__tDE93"};